import { render, staticRenderFns } from "./ehc-form-property-types.vue?vue&type=template&id=79b59bfe&scoped=true"
import script from "./ehc-form-property-types.vue?vue&type=script&lang=js"
export * from "./ehc-form-property-types.vue?vue&type=script&lang=js"
import style0 from "./ehc-form-property-types.vue?vue&type=style&index=0&id=79b59bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b59bfe",
  null
  
)

export default component.exports